<template>

  <div class="kd-landing">

    <pdfinfodown ref="pdfinfodown" />

    <!-- 로그인 유도 팝업 -->
    <v-dialog  persistent overlay-color="#000000FF"  v-model="login_dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown ? true : false"
      :width="$vuetify.breakpoint.smAndDown ? '100%' : '600px'"
      class="none_radius">

      <v-card class="pa-0 ma-0">

        <v-card-title class="ma-0 pa-0" style="overflow:hidden">
        <v-row dense align="center" justify="center">
          <v-col cols="12"  align="center" style="height:70px;background:black" class="d-flex align-center justify-center">
            <span style="color:white">KDGE</span>
          </v-col>
        </v-row>
        </v-card-title>

        <v-card-text>
          <v-spacer/>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" align="center"> <!-- 해상도 조절 컬럼 -->

              <v-row dense align="center" justify="center" class="mt-10 mt-md-10 ma-0">
                <v-col cols="12" md="10" align="center" class="ma-0 pa-0">
                  <div class="text-center ma-0 pa-0 dialog_subtitle_kor"
                    :style="$vuetify.breakpoint.smAndDown ? 'font-size:18px' : 'font-size:22px'"
                    >다이아몬드 보석 판매가격 문의는 회원가입이 필요합니다.<br><span class="dialog_subtitle_eng">Inquiries about diamond jewelry sales prices require membership registration.</span></div>

                </v-col>
                <v-col cols="12" md="10" class="ma-0 pa-0">
                  <v-btn elevation="0" class="black_btn" width="100%" height="50px" @click="goJoin">Join 가입하기</v-btn>
                </v-col>
              </v-row>

              <v-row dense align="center" justify="center" class="mt-10 mt-md-10 ma-0">
                <v-col cols="12" md="10" align="center" class="ma-0 pa-0">
                  <p class="text-center ma-0 pa-0 dialog_subtitle_kor"
                    :style="$vuetify.breakpoint.smAndDown ? 'font-size:18px' : 'font-size:22px'"
                    >회원이시면 로그인해주세요<br><span class="dialog_subtitle_eng">If you are a member, please log in.</span></p>
                </v-col>
                <v-col cols="12" md="10" class="ma-0 pa-0">
                  <v-btn elevation="0" class="black_btn" width="100%" height="50px" @click="goLogin">Login 로그인</v-btn>
                </v-col>
              </v-row>

            </v-col>
          </v-row>
          <v-spacer/>
        </v-card-text>

        <v-card-actions class="mt-5 mb-1">
          <v-row align="center" justify="center">
            <v-col cols="12"> <!-- 해상도 조절 컬럼 -->
              <v-row class="ma-0 pa-0" justify="center">
                <v-col cols="12" md="10" class="ma-0 pa-0">
                  <v-btn elevation="0" class="white_btn" width="100%" height="50px" @click="login_dialog = false">Close 닫기</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- 히어로 -->
    <section class="hero">
      <div class="hero-bg"><div class="glow"></div></div>
      <div class="wrap">
        <div class="eyebrow">Korea Gold · Silver · Gem Exchange</div>
        <h1 class="hero-title">kGoldGem<br>한국금은보석<br><em>Digital</em> 거래소</h1>
        <p class="sub">천연·렙그로운 다이아몬드, 천연보석, 주얼리, 골드바까지.<br>
          <b>투명한 시세</b>와 <b>검증된 공급자</b>가 만나는 디지털 보석 거래 플랫폼.</p>
      </div>
    </section>

    <!-- 카테고리 -->
    <section class="section">
      <div class="wrap">
        <div class="sec-head">
          <h2>Categories <small>카테고리</small></h2>
        </div>
        <div class="cats">
          <a class="cat" v-for="cat in categories" :key="cat.type" @click="type_select(cat.type)">
            <img :src="cat.img" :alt="cat.kor">
            <div class="arrow"><i class="mdi mdi-arrow-top-right"></i></div>
            <div class="lbl"><strong>{{ cat.kor }}</strong><span>{{ cat.eng }}</span></div>
          </a>
        </div>
      </div>
    </section>

    <!-- 시세 정보 -->
    <section class="section">
      <div class="wrap">

        <div class="sec-head">
          <h2>Market <small>시세 정보</small></h2>
        </div>
        <div class="market">
          <div class="mk">
            <div class="mk-h"><b>RAPAPORT</b></div>
            <strong>다이아몬드 국제 시세표</strong>
            <div class="mk-links">
              <a @click="openRapa('ROUNDS')">Rounds</a>
              <a @click="openRapa('PEARS')">Pears</a>
            </div>
          </div>
          <a class="mk" @click="goFindPrice">
            <div class="mk-h"><b>GOLD PRICE</b><span>실시간</span></div>
            <strong>금시세표<small>순금 1돈(3.75g)</small></strong>
            <div class="mk-row"><span>내가 살 때</span><em>{{ fmtNum(price.gold24_buy) }}원 <i v-if="price.gold24_buy_diff != null" :class="chgClass(price.gold24_buy_diff)">{{ chgText(price.gold24_buy_diff, 0) }} {{ pct(price.gold24_buy_rate) }}</i></em></div>
            <div class="mk-row"><span>내가 팔 때</span><em>{{ fmtNum(price.gold24_sell) }}원 <i v-if="price.gold24_sell_diff != null" :class="chgClass(price.gold24_sell_diff)">{{ chgText(price.gold24_sell_diff, 0) }} {{ pct(price.gold24_sell_rate) }}</i></em></div>
          </a>
          <a class="mk" @click="goFindPrice">
            <div class="mk-h"><b>EXCHANGE RATE</b><span>실시간</span></div>
            <strong>국제환율</strong>
            <div class="mk-row"><span>USD / KRW</span><em>{{ fmtNum(price.usd_krw) }}원 <i v-if="price.usd_krw_diff != null" :class="chgClass(price.usd_krw_diff)">{{ chgText(price.usd_krw_diff, 2) }} {{ pct(price.usd_krw_rate) }}</i></em></div>
            <div class="mk-row"><span>Gold (USD/oz)</span><em>{{ fmtNum(price.gold_oz) }}$ <i v-if="price.gold_oz_diff != null" :class="chgClass(price.gold_oz_diff)">{{ chgText(price.gold_oz_diff, 2) }} {{ pct(price.gold_oz_rate) }}</i></em></div>
          </a>
        </div>
        <a class="market-cta" @click="goFindPrice">
          <i class="mdi mdi-chart-line"></i>
          <span><strong>금시세표 · 국제환율</strong><small>순금·은·백금 시세와 주요 통화 환율을 상세하게 확인하세요</small></span>
          <i class="mdi mdi-arrow-right arr"></i>
        </a>

      </div>
    </section>

    <section class="section">
      <div class="wrap">

        <!-- 바로가기 -->
        <div class="sec-head">
          <h2>Services <small>바로가기</small></h2>
          <a class="more" @click="gomoreinfo">More Info 더보기 <i class="mdi mdi-arrow-right"></i></a>
        </div>
        <div class="actions">
          <a class="act vivid" @click="govivid">
            <img src="https://storage.googleapis.com/sndge-3f7bb.appspot.com/website/vivd-logo.png" alt="Vivid Diamond">
            <div class="t"><small>Brand</small><strong>비비드 다이아몬드<br>브랜드 알아보기</strong></div>
          </a>
          <a class="act" @click="gofindshop">
            <div class="ic"><i class="mdi mdi-map-marker-radius-outline"></i></div>
            <div class="t"><small>Find Store</small><strong>내 주변 소매점 찾기</strong></div>
          </a>
          <a class="act" @click="gosalereq">
            <div class="ic"><i class="mdi mdi-tag-text-outline"></i></div>
            <div class="t"><small>Sell</small><strong>내 다이아몬드 보석<br>판매 가격 알아보기</strong></div>
          </a>
          <a class="act" @click="goauction">
            <div class="ic"><i class="mdi mdi-gavel"></i></div>
            <div class="t"><small>Online Jewelry Auction</small><strong>온라인 보석 경매</strong></div>
          </a>
        </div>

      </div>
    </section>

    <!-- 즉시구매 찾기 - 상품목록의 '즉시납품 Domestic STOCK in Korea' 체크된 상태(isquick=1)로 진입 -->
    <section class="section">
      <div class="wrap">
        <div class="sec-head">
          <h2>Quick Buy <small>즉시구매 찾기</small></h2>
        </div>
        <div class="quick">
          <div class="quick-info">
            <div class="ic"><i class="mdi mdi-truck-fast-outline"></i></div>
            <div class="t">
              <small>Domestic STOCK in Korea</small>
              <strong>국내 재고 즉시납품 상품만<br>바로 찾아보세요</strong>
            </div>
          </div>
          <div class="quick-list">
            <a class="qbtn" v-for="q in quicks" :key="q.type" @click="type_select(q.type, 1)">
              <i :class="'mdi ' + q.icon"></i>
              <span><strong>{{ q.kor }}</strong><small>{{ q.eng }}</small></span>
              <i class="mdi mdi-chevron-right arr"></i>
            </a>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>

export default {

    mounted() {
      this.loadpage();
      this.loadprice();
    },

    data: () => ({
      nextpage:'',
      login_dialog : false,
      editedItem:null,

      categories:[
          {type:8, kor:'골드바 · 실버바',             eng:'GoldBar · SilverBar',            img:'https://storage.googleapis.com/sndge-3f7bb.appspot.com/website/goldbar_home6.png'}
        , {type:4, kor:'천연 다이아몬드',       eng:'Natural Diamond',          img:'https://storage.googleapis.com/sndge-3f7bb.appspot.com/website/nd_home4.png'}
        , {type:5, kor:'팬시컬러 렙그로운 다이아몬드', eng:'Fancy Color Lab-Grown Diamond',  img:'https://storage.googleapis.com/sndge-3f7bb.appspot.com/website/ld_home4.png'}
        , {type:1, kor:'천연보석',                    eng:'Gemstone',                       img:'https://storage.googleapis.com/sndge-3f7bb.appspot.com/website/gem_home5.png'}
        , {type:2, kor:'주얼리',                      eng:'Jewelry',                        img:'https://storage.googleapis.com/sndge-3f7bb.appspot.com/website/jew_home2.png'}
      ],

      //즉시구매 찾기 (type은 type_select 인덱스와 동일)
      quicks:[
          {type:4, kor:'천연 다이아몬드',       eng:'Natural Diamond',          icon:'mdi-diamond-stone'}
        , {type:5, kor:'팬시컬러 렙그로운 다이아몬드', eng:'Fancy Color Lab-Grown Diamond',  icon:'mdi-diamond-outline'}
        , {type:1, kor:'천연보석',                    eng:'Gemstone',                       icon:'mdi-cards-diamond-outline'}
        , {type:2, kor:'주얼리',                      eng:'Jewelry',                        icon:'mdi-ring'}
      ],

      //금시세/환율 - 시세 API 연동 전까지 null (화면에는 — 로 표시, 등락률은 숨김)
      price:{
          gold24_buy:null,   gold24_buy_diff:null,   gold24_buy_rate:null
        , gold24_sell:null,  gold24_sell_diff:null,  gold24_sell_rate:null
        , usd_krw:null,     usd_krw_diff:null,     usd_krw_rate:null
        , gold_oz:null,     gold_oz_diff:null,     gold_oz_rate:null
      },
    }),

    created(){

      //이벤트 수신 - 라파포트 갱신용
      this.$EventBus.$on('reloadrapa', this.loadpage);

    },

    beforeDestroy(){
      this.$EventBus.$off('reloadrapa');
    },

    beforeRouteLeave(to, from, next){
      console.log("beforeRouteLeave");
      if(this.$refs.pdfinfodown.pdf_dialog){
        this.$refs.pdfinfodown.close();
        next(false);
      }else{
        next();
      }
    },

    methods: {


      //라파포트 시세표 PDF 경로 - 비로그인 포함 누구나 조회 (토큰 없이 호출)
      loadpage(){

        this.$http.post(this.$host+'/GuestRapaPdf',{
        })
        .then((result)=>{
          if(result.data.resultCode == 0){
              this.editedItem = result.data.resultData[0];
              this.$forceUpdate();
          }

        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
        });

      },

      //시세 카드 - 서버가 30분마다 수집한 DB 값 (실패 시 — 표시 유지)
      loadprice(){
        this.$http.post(this.$host+'/GuestPriceInfo',{
        })
        .then((result)=>{
          if(result.data.resultCode == 0 && result.data.resultData != null){
            Object.assign(this.price, result.data.resultData.landing);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
        });
      },

      openchat(){
        window.ChannelIO('showMessenger');
      },

      //isquick 1이면 검색옵션의 '즉시납품 Domestic STOCK in Korea' 체크된 상태로 진입
      type_select(type_index, isquick = 0){
        //상품목록 맨 위에서 시작 (라우터에 scrollBehavior가 없어 랜딩의 스크롤 위치가 유지됨)
        window.scrollTo(0, 0);
        this.PRODUCT_CLASS = type_index;
        if(type_index == 4){
          //천연
          this.PRODUCT_CLASS = 0;
          this.$router.push({path:"/ProductList", query:{code:this.PRODUCT_CLASS, page:1, rtype:1, dtype:0, vivid:0, isquick:isquick}});
        }else if(type_index == 5){
          //합성
          this.PRODUCT_CLASS = 0;
          this.$router.push({path:"/ProductList", query:{code:this.PRODUCT_CLASS, page:1, rtype:1, dtype:1, vivid:0, isquick:isquick}});
        }else if(type_index == 8){
          //골드바 실버바
          this.PRODUCT_CLASS = 2;
          this.$router.push({path:"/ProductList", query:{code:this.PRODUCT_CLASS, page:1, rtype:1, vivid:0, isquick:isquick, isbar:1 }});
        }else{
          this.$router.push({path:"/ProductList", query:{code:this.PRODUCT_CLASS, page:1, rtype:1, vivid:0, isquick:isquick}});
        }
        //this.$router.push({path:"SearchOption", query:{code:this.PRODUCT_CLASS}});

        //this.search_run();
      },

      goProductList(){
        this.$router.push({path:"/ProductList", query:{code:0, page:1, rtype:1}});
      },

      goNotice(){
        this.$router.push({path:"/Notice", query:{stype:0}});
      },

      govivid(){
        //다이아몬드 디폴트로 비비드 제품 표시
        this.PRODUCT_CLASS = 0;
        this.$router.push({path:"/ProductList", query:{code:this.PRODUCT_CLASS, page:1, rtype:1, vivid:1, dtype:0}}); //비비드는 천연만
        //this.$router.push("/VividDiamond");
      },

      gocraft(){
        this.PRODUCT_CLASS = 3;
        this.$router.push({path:"/ProductList", query:{code:this.PRODUCT_CLASS, page:1, rtype:1, vivid:0, dtype:0, isquick:0}});
      },

      gofindshop(){
        this.$router.push("/FindShop");
      },

      gohowmuch(){
        this.$router.push("/UserSaleReq");
      },

      gomoreinfo(){
        this.$router.push("/MoreInfo");
      },

      goauction(){

        this.$fire({
          html: "This feature is being prepared.<br><br>준비중인 기능입니다.",
          confirmButtonText:"<div style='font-size:14px;line-height:15px'>Confirm<br>확인</div>",
          confirmButtonColor: '#000000',
          allowEscapeKey:false,
          allowOutsideClick:false,
          allowEnterKey:true,
        });

      },

      //금시세표 · 국제환율
      goFindPrice(){
        this.$router.push("/FindPrice");
      },

      gosalereq(){
        if(this.$session.get("GRADE") >= 1){
          //판매요청으로 이동
          this.$router.push("/UserSaleReq");
        }else{
          //로그인 유도
          this.nextpage = "UserSaleReq";
          this.login_dialog = true;
        }

      },

      goLogin(){
        this.$router.push({path:"/Login", query:{next:this.nextpage}});
      },

      goJoin(){
        this.$router.push({path:"/Join"});
      },

      goEvent(){
        this.$router.push({path:"/ProductList", query:{code:0, page:1, rtype:1, vivid:0, stype:1}});
      },

      //라파포트 시세표 - 공급자 또는 VIVID CLUB 회원만
      //라파포트 시세표 - 로그인 없이도 열람/다운로드 가능
      openRapa(kind){
        if(this.editedItem == null) return;
        const url = kind == 'ROUNDS' ? this.editedItem.RAPA_ROUNDS : this.editedItem.RAPA_PEARS;
        if(url == null || url.length < 1) return;
        this.showImage_pdf_popup(url);
      },

      //여기서 PDF의 라파포트 시세 확인
      showImage_pdf_popup(url){
        this.$refs.pdfinfodown.geturl(url);
      },

      fmtNum(value){
        return value == null ? '—' : Number(value).toLocaleString();
      },

      //전일 대비 - 상승 빨강, 하락 파랑, 보합 회색
      chgClass(diff){
        return diff > 0 ? 'up' : diff < 0 ? 'dn' : 'eq';
      },

      chgText(diff, digits){
        const mark = diff > 0 ? '▲' : diff < 0 ? '▼' : '-';
        return mark + ' ' + Math.abs(diff).toLocaleString(undefined, {minimumFractionDigits:digits, maximumFractionDigits:digits});
      },

      pct(rate){
        return rate == null ? '' : '(' + Math.abs(rate).toFixed(2) + '%)';
      },

    },



}
</script>


<style scoped>

.kd-landing{
  --bg:#0a0a0a; --panel:#161616; --panel2:#1f1f1f; --line:#2c2c2c;
  --muted:#9a9a9a; --gold:#d4b56a;
  background:var(--bg);
  color:#ffffff;
  min-height:100%;
  padding-bottom:60px;
  font-family:'Inter','Noto Sans KR',sans-serif !important;
  -webkit-font-smoothing:antialiased;
  word-break:keep-all;
}
.kd-landing a{color:inherit;text-decoration:none;cursor:pointer}
.wrap{max-width:1200px;margin:0 auto;padding:0 40px}

/* hero */
.hero{position:relative;padding:96px 0 40px;overflow:hidden}
.hero-bg{position:absolute;inset:0;pointer-events:none}
.hero .wrap{position:relative}
.hero-bg .glow{position:absolute;left:-10%;top:-30%;width:600px;height:600px;border-radius:50%;
  background:radial-gradient(circle,rgba(212,181,106,.18),transparent 65%);filter:blur(10px)}
.eyebrow{display:block;font-size:12px;letter-spacing:.2em;text-transform:uppercase;color:var(--gold);font-weight:600;margin-bottom:22px}
.hero-title{margin:0;font-size:clamp(48px,6.5vw,88px);line-height:.98;font-weight:800;letter-spacing:-2px;color:#ffffff}
.hero-title em{font-style:normal;color:var(--gold)}
.sub{margin:22px 0 0;font-size:18px;color:#cfcfcf;font-family:'Noto Sans KR',sans-serif;font-weight:300;max-width:560px;line-height:1.6}
.sub b{color:#fff;font-weight:500}

/* section */
.section{padding:40px 0}
.sec-head{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:22px}
.sec-head h2{margin:0;font-size:22px;font-weight:700;letter-spacing:-.3px;color:#ffffff}
.sec-head h2 small{font-family:'Noto Sans KR',sans-serif;font-weight:400;font-size:14px;color:var(--muted);margin-left:10px}
.kd-landing .sec-head a.more{font-size:13px;color:var(--muted);transition:.2s}
.kd-landing .sec-head a.more:hover{color:#fff}

/* categories */
.cats{display:grid;grid-template-columns:repeat(5,1fr);gap:14px}
.cat{position:relative;aspect-ratio:1/1.15;border-radius:16px;overflow:hidden;background:var(--panel);border:1px solid var(--line)}
.cat img{width:100%;height:100%;object-fit:cover;transition:transform .8s ease;display:block}
.cat:hover img{transform:scale(1.08)}
.cat .lbl{position:absolute;left:0;right:0;bottom:0;padding:18px 18px 16px;
  background:linear-gradient(0deg,rgba(0,0,0,.85),rgba(0,0,0,0))}
.cat .lbl strong{display:block;font-family:'Noto Sans KR',sans-serif;font-size:17px;font-weight:500}
.cat .lbl span{font-size:12px;color:#bdbdbd;letter-spacing:.02em}
.cat .arrow{position:absolute;top:14px;right:14px;width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,.12);
  display:grid;place-items:center;opacity:0;transform:translateY(-4px);transition:.25s}
.cat:hover .arrow{opacity:1;transform:none}

/* quick actions */
.actions{display:grid;grid-template-columns:repeat(4,1fr);gap:14px}
.act{background:var(--panel);border:1px solid var(--line);border-radius:16px;padding:22px;min-height:132px;
  display:flex;flex-direction:column;justify-content:space-between;transition:.2s}
.act:hover{border-color:var(--gold);background:var(--panel2)}
.act .ic{width:40px;height:40px;border-radius:10px;background:rgba(212,181,106,.12);color:var(--gold);display:grid;place-items:center;font-size:22px}
.act .t{margin-top:16px}
.act .t small{display:block;font-size:11.5px;color:var(--muted);letter-spacing:.06em;text-transform:uppercase}
.act .t strong{display:block;font-family:'Noto Sans KR',sans-serif;font-size:17px;font-weight:500;margin-top:4px;line-height:1.35}
.act.vivid{background:linear-gradient(135deg,#1b1b1b,#2a2416);border-color:#3b3221}
.act.vivid:hover{border-color:var(--gold)}
.act.vivid img{height:26px;width:auto;align-self:flex-start}

/* quick buy (즉시구매 찾기) */
.quick{background:linear-gradient(135deg,#1b1b1b,#2a2416);border:1px solid #3b3221;border-radius:16px;padding:22px;
  display:grid;grid-template-columns:1fr;gap:18px;align-items:center}
.quick-info{display:flex;align-items:center;gap:14px;min-width:0}
.quick-info .ic{flex:none;width:48px;height:48px;border-radius:12px;background:rgba(212,181,106,.14);color:var(--gold);display:grid;place-items:center;font-size:26px}
.quick-info .t small{display:block;font-size:11.5px;color:var(--gold);letter-spacing:.06em;text-transform:uppercase;font-weight:600}
.quick-info .t strong{display:block;font-family:'Noto Sans KR',sans-serif;font-size:17px;font-weight:500;margin-top:4px;line-height:1.4}
.quick-list{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;min-width:0}
.qbtn{min-width:0;background:rgba(10,10,10,.55);border:1px solid #3a3a3a;border-radius:12px;padding:14px;display:flex;align-items:center;gap:10px;transition:.2s}
.qbtn:hover{border-color:var(--gold);background:rgba(10,10,10,.8)}
.qbtn>i{flex:none;font-size:22px;color:var(--gold)}
.qbtn span{display:flex;flex-direction:column;min-width:0}
.qbtn strong{font-family:'Noto Sans KR',sans-serif;font-size:14px;font-weight:500;line-height:1.3}
.qbtn small{font-size:11px;color:#bdbdbd;margin-top:2px;line-height:1.3}
.qbtn .arr{margin-left:auto;font-size:20px;color:#8a8a8a}
.qbtn:hover .arr{color:var(--gold)}

/* market info */
.market{display:grid;grid-template-columns:repeat(3,1fr);gap:14px}
.market>*{min-width:0}
.mk{background:var(--panel);border:1px solid var(--line);border-radius:16px;padding:20px 22px;display:flex;flex-direction:column;gap:10px;transition:.2s}
.mk:hover{border-color:var(--gold);background:var(--panel2)}
.mk-h{display:flex;align-items:center;justify-content:space-between}
.mk-h b{color:var(--gold);letter-spacing:.14em;font-size:12px}
.mk-h span{font-size:11px;color:#777;border:1px solid #333;border-radius:999px;padding:2px 8px}
.mk strong{font-family:'Noto Sans KR',sans-serif;font-size:18px;font-weight:500}
.mk strong small{font-weight:400;font-size:12px;color:var(--muted);margin-left:8px}
.mk-links{display:flex;gap:8px}
.kd-landing .mk-links a{padding:6px 14px;border:1px solid #3a3a3a;border-radius:999px;font-size:13px;transition:.2s}
.kd-landing .mk-links a:hover{border-color:var(--gold);color:var(--gold)}
.mk-row{display:flex;justify-content:space-between;align-items:baseline;font-size:13px;color:#bdbdbd;border-top:1px solid var(--line);padding-top:8px}
.mk-row em{font-style:normal;color:#fff;font-weight:600;font-size:15px}
.mk-row i{font-style:normal;font-size:11.5px;margin-left:4px}
.mk-row i.up{color:#e5675c}
.mk-row i.dn{color:#5ea0e6}
.mk-row i.eq{color:#8a8a8a}
.kd-landing .market-cta{margin-top:14px;display:flex;align-items:center;gap:16px;padding:18px 24px;border-radius:16px;background:var(--gold);color:#111;transition:.2s}
.kd-landing .market-cta:hover{background:#e6c97f}
.market-cta>i{font-size:26px}
.market-cta span{display:flex;flex-direction:column;gap:2px;min-width:0}
.market-cta strong{font-family:'Noto Sans KR',sans-serif;font-size:18px;font-weight:700}
.market-cta small{font-family:'Noto Sans KR',sans-serif;font-size:13px;color:#3d3416}
.market-cta .arr{margin-left:auto;font-size:24px}

@media (max-width:1024px){
  .cats{grid-template-columns:repeat(3,1fr)}
  .actions{grid-template-columns:repeat(2,1fr)}
  .quick{grid-template-columns:1fr;gap:18px}
  .quick-list{grid-template-columns:repeat(2,1fr)}
}
@media (max-width:640px){
  .wrap{padding:0 18px}
  .hero{padding:56px 0 30px}
  .cats{grid-template-columns:repeat(2,1fr);gap:10px}
  .cat:first-child{grid-column:span 2;aspect-ratio:2/1}
  .cat:first-child .lbl strong{font-size:19px}
  .actions{grid-template-columns:1fr 1fr;gap:10px}
  .quick{padding:16px;gap:14px}
  .quick-info .ic{width:42px;height:42px;font-size:23px}
  .quick-info .t strong{font-size:15px}
  .quick-list{grid-template-columns:1fr;gap:8px}
  .qbtn{padding:13px 14px;gap:12px}
  .qbtn>i{font-size:22px}
  .qbtn strong{font-size:14px}
  .qbtn small{font-size:11px}
  .act{padding:16px;min-height:112px;min-width:0}
  .act .t strong{font-size:15px}
  .act.vivid img{max-width:100%;height:auto;max-height:22px}
  .market{grid-template-columns:1fr;gap:10px}
  .mk{padding:16px 18px}
  .kd-landing .market-cta{padding:14px 16px;gap:12px;margin-top:10px}
  .market-cta strong{font-size:16px}
  .market-cta small{font-size:12px}
  .sec-head{flex-wrap:wrap;gap:4px}
  .eyebrow{font-size:11px;letter-spacing:.12em;white-space:nowrap;margin-bottom:16px}
  .hero-title{font-size:44px;letter-spacing:-1.5px}
  .sub{font-size:15px}
}

.dialog_subtitle_kor{
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  color: #090808;
  line-height: 26px;
}

.dialog_subtitle_eng{
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  color:black;
}

</style>
